/* tslint:disable */
/* eslint-disable */
/**
 * Products API
 * API for managing products
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BrokerProductDto } from './BrokerProductDto';
import {
    BrokerProductDtoFromJSON,
    BrokerProductDtoFromJSONTyped,
    BrokerProductDtoToJSON,
    BrokerProductDtoToJSONTyped,
} from './BrokerProductDto';

/**
 * Response containing the list of products accessible to the broker
 * @export
 * @interface GetBrokerProductsResponse
 */
export interface GetBrokerProductsResponse {
    /**
     * List of products the broker has access to
     * @type {Array<BrokerProductDto>}
     * @memberof GetBrokerProductsResponse
     */
    products?: Array<BrokerProductDto>;
}

/**
 * Check if a given object implements the GetBrokerProductsResponse interface.
 */
export function instanceOfGetBrokerProductsResponse(value: object): value is GetBrokerProductsResponse {
    return true;
}

export function GetBrokerProductsResponseFromJSON(json: any): GetBrokerProductsResponse {
    return GetBrokerProductsResponseFromJSONTyped(json, false);
}

export function GetBrokerProductsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBrokerProductsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'products': json['products'] == null ? undefined : ((json['products'] as Array<any>).map(BrokerProductDtoFromJSON)),
    };
}

export function GetBrokerProductsResponseToJSON(json: any): GetBrokerProductsResponse {
    return GetBrokerProductsResponseToJSONTyped(json, false);
}

export function GetBrokerProductsResponseToJSONTyped(value?: GetBrokerProductsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'products': value['products'] == null ? undefined : ((value['products'] as Array<any>).map(BrokerProductDtoToJSON)),
    };
}

